import { render, staticRenderFns } from "./ShoppinglistOverlay.vue?vue&type=template&id=beaac632&"
import script from "./ShoppinglistOverlay.vue?vue&type=script&lang=js&"
export * from "./ShoppinglistOverlay.vue?vue&type=script&lang=js&"
import style0 from "./ShoppinglistOverlay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports